import { ArtistImage } from "models/ArtistImage";
import { useState } from "react";
import { ApiService } from "services/ApiService";

interface ArtistImageProps {
  artistImage: ArtistImage;
  artistId: string;
  isVisitor: boolean;
  onClick?: () => void;
  onDeleteClick?: (image: ArtistImage) => void;
  isEditable?: boolean;
}

const ArtistImageComponent: React.FC<ArtistImageProps> = ({ artistImage, artistId, isVisitor, onClick, onDeleteClick, isEditable }) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const endpoint = `${API_BASE_URL}/artistimages/${artistId}/${artistImage.id}`;
  const [isEditing, setIsEditing] = useState(false); // State to manage editing mode
  const [name, setName] = useState(artistImage.name); // State for the name being edited

  const handleSave = async () => {
    try {

      // Call the updateArtistImage API
      const response = await ApiService.updateArtistImage(artistId, artistImage.id, name);

      if (response.success) {
        setIsEditing(false); // Exit editing mode
      } else {
        console.error("Failed to update image name:", response.errors);
        alert("Failed to update the image name. Please try again.");
      }
    } catch (error) {
      console.error("Error updating image name:", error);
      alert("An error occurred while updating the image name.");
    }
  };

  return (
    <div className="text-center p-4 bg-gray-100 rounded-lg shadow-md">
      {isEditing ? (
        <>
          {/* Editable Textbox */}
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <img
            src={endpoint}
            alt={artistImage.name}
            className="max-w-full h-96 object-cover rounded-lg mb-4"
          />
          {/* Save Button */}
          <button
            onClick={handleSave}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400"
          >
            Save
          </button>
          <button
            onClick={() => onDeleteClick && onDeleteClick(artistImage)}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-green-400"
          >
            Delete
          </button>
        </>
      ) : (
        <>
          {/* Display Name */}
          <h2 className="text-2xl font-bold text-gray-800 mb-4">{artistImage.name}</h2>
          {/* Image */}
          <div onClick={onClick} className="cursor-pointer">
          <img
            src={endpoint}
            alt={artistImage.name}
            className="max-w-full h-96 object-cover rounded-lg mb-4"
          />
          </div>

          {/* Description */}
          <p className="text-gray-600">{artistImage.description}</p>
          {/* Edit Button (only if not a visitor) */}
          {!isVisitor && isEditable && (
            <button
              onClick={() => setIsEditing(true)}
              className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              Edit
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default ArtistImageComponent;